
export const SECCION_TYPE = {

    TEXTO: 310,
    CONCEPTOS: 311,
    CODIGO_BARRAS: 312,
    IMAGEN: 313

}